export default __webpack_public_path__ + "static/media/julia-set.7b9c338b.gif";